export default __webpack_public_path__ + "39e95e0e4b433d611c9cc43daf8a03c0.png";